export const enum HTTP_METHODS {
    GET = "GET",
    POST = "POST",
    DELETE = "DELETE",
    PATCH = "PATCH",
}

export const DOWNSTREAM_TRIGGER_SOURCE = {
    API_SERVER: "api-server",
    WEB_APP: "web-app",
};

export const DEFAULT_API_RETRY_DELAY_TIME_IN_MS = 100;

export const ADDITIONAL_API_HEADERS_FOR_PL_APIS = {
    "agent-type": "webview",
};
